import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import currencySymbolMap from "currency-symbol-map";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Autocomplete, Box, IconButton, TableFooter, TextField } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  AllCountriesModel,
  AppraisalAssetsModel,
  AppraisalsDetailsModelForEquity,
} from "../../../all_Interfaces";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { updateAppraisalDetailsForUSAppraisal } from "../../../redux/slices/AppraisalDetailsForUSAppraisalSlice";
import dayjs, { Dayjs } from "dayjs";
import { updateAppraisalAssets } from "../../../redux/slices/AppraisalAssetsSlice";

export const AppraisalValueTable = (props: any) => {
  const dispatch = useAppDispatch();
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [currencyObj, setCurrencyObj] = useState<AllCountriesModel>({
    id: 4,
    countryName: "United States of America",
    countryCode: "USD",
    localId: "en_US",
  });
  const [currencySymbol, setCurrencySymbol] = useState<string>("");
  const [appraisalsDetails, setAppraisalDetails] =
    useState<AppraisalsDetailsModelForEquity>({
      currentAppraisalValue: null,
      effectiveDateOfValue: "",
      sheduled_n_cost: null,
      GPAppraisalValue:null,
      lastAppraisedValue: null,
      lastAppraisalPercentageChange: null,
      lastAppraisedDate: "",
      lastAnnualAppraisedValue: null,
      lastAnnualAppraisalPercentageChange: null,
      lastAnnualAppraisedDate: "",
      currencySelected: "",
    });
  const today: dayjs.Dayjs = dayjs();
  const toDay: string = today.format("DD-MM-YYYY HH:mm:ss");
  console.log(dayjs(toDay, "MM-DD-YYYY"));

  const appraisalDetailsForUSAppraisal: AppraisalsDetailsModelForEquity =
    useAppSelector((state) => state.AppraisalDetailsForUSAppraisal.data);
    
  const modifiedAssets: AppraisalAssetsModel[] = useAppSelector(
    (state) => state.AppraisalAssets.data
  );
  const submitEvent: boolean = useAppSelector(
    (state) => state.AppraisalSubmitEvent.data
  );
  const [modifiedAsset, setModifiedAsset] = useState<AppraisalAssetsModel[]>(
    []
  );

  useEffect(() => {
    setModifiedAsset(modifiedAssets);
    console.log(modifiedAssets);
  }, [modifiedAssets]);

  // useEffect(() => {
  //   dispatch(updateAppraisalAssets(modifiedAssets));
  //   console.log(modifiedAssets);
  // }, [appraisalsDetails]);

  useEffect(() => {
    setIsSubmit(submitEvent);
  }, [submitEvent]);

  useEffect(() => {
    setAppraisalDetails({
      ...appraisalsDetails,
      currentAppraisalValue:
        appraisalDetailsForUSAppraisal.currentAppraisalValue != null
          ? formatNumberWithCommas(appraisalDetailsForUSAppraisal.currentAppraisalValue)
          : null,
      effectiveDateOfValue:
        appraisalDetailsForUSAppraisal.effectiveDateOfValue != null
          ? appraisalDetailsForUSAppraisal.effectiveDateOfValue
          : dayjs(today).format("MM-DD-YYYY"),
      sheduled_n_cost:
        appraisalDetailsForUSAppraisal.sheduled_n_cost != null
          ? formatNumberWithCommas(appraisalDetailsForUSAppraisal.sheduled_n_cost)
          : null,
      lastAppraisedValue:
        appraisalDetailsForUSAppraisal.lastAppraisedValue != null
          ? formatNumberWithCommas(appraisalDetailsForUSAppraisal.lastAppraisedValue)
          : null,
      lastAnnualAppraisedValue:
        appraisalDetailsForUSAppraisal.lastAnnualAppraisedValue != null
          ? formatNumberWithCommas(appraisalDetailsForUSAppraisal.lastAnnualAppraisedValue)
          : null,
      lastAnnualAppraisedDate:
        appraisalDetailsForUSAppraisal.lastAnnualAppraisedDate != null
          ? appraisalDetailsForUSAppraisal.lastAnnualAppraisedDate
          : "",
      lastAppraisedDate:
        appraisalDetailsForUSAppraisal.lastAppraisedDate != null
          ? appraisalDetailsForUSAppraisal.lastAppraisedDate
          : "",
      currencySelected:
        appraisalDetailsForUSAppraisal.currencySelected != null
          ? appraisalDetailsForUSAppraisal.currencySelected
          : "",
      lastAnnualAppraisalPercentageChange:
        appraisalDetailsForUSAppraisal.lastAnnualAppraisalPercentageChange !=
          null && appraisalDetailsForUSAppraisal.lastAnnualAppraisalPercentageChange != Infinity
          ? appraisalDetailsForUSAppraisal.lastAnnualAppraisalPercentageChange
          : null,
      lastAppraisalPercentageChange:
        appraisalDetailsForUSAppraisal.lastAppraisalPercentageChange != null 
        && appraisalDetailsForUSAppraisal.lastAppraisalPercentageChange != Infinity
          ? appraisalDetailsForUSAppraisal.lastAppraisalPercentageChange
          : null,
      GPAppraisalValue:appraisalDetailsForUSAppraisal.GPAppraisalValue !=
          null
          ? formatNumberWithCommas(appraisalDetailsForUSAppraisal.GPAppraisalValue)
          : null,
    });
    console.log(props.countriesData);
    var countriesData:AllCountriesModel[] = [...props.countriesData];
    var cur:string = appraisalDetailsForUSAppraisal.currencySelected != ""? appraisalDetailsForUSAppraisal.currencySelected:"USD";
    var a = countriesData.find((a) =>  a.countryCode == cur);
    if(a != undefined)
    setCurrencyObj(a);

  }, [appraisalDetailsForUSAppraisal]);


  const checkForPercentage = (annualOrPast:string) => {
    if(annualOrPast === "annual"){
      if (appraisalDetailsForUSAppraisal.lastAnnualAppraisalPercentageChange != null
        && appraisalDetailsForUSAppraisal.lastAnnualAppraisalPercentageChange != Infinity) {

        if (appraisalDetailsForUSAppraisal.currentAppraisalValue != null && appraisalDetailsForUSAppraisal.currentAppraisalValue != 0
          && appraisalDetailsForUSAppraisal.lastAnnualAppraisedValue != null && appraisalDetailsForUSAppraisal.lastAnnualAppraisedValue != 0
        ) {
          let percentage =
            ((Number(appraisalDetailsForUSAppraisal.currentAppraisalValue.toString().replace(/,/g, "")) -
              Number(appraisalDetailsForUSAppraisal.lastAnnualAppraisedValue.toString().replace(/,/g, ""))) /
              Number(appraisalDetailsForUSAppraisal.lastAnnualAppraisedValue.toString().replace(/,/g, ""))) *
            100;
          return parseFloat(percentage.toFixed(2));
        }else {
          return appraisalDetailsForUSAppraisal.lastAnnualAppraisalPercentageChange;
        }

      }else{
        return null;
      }
            // ? appraisalDetailsForUSAppraisal.lastAppraisalPercentageChange
            // : null;
    }else 
    if(annualOrPast === "past"){
      if (appraisalDetailsForUSAppraisal.lastAppraisalPercentageChange != null
        && appraisalDetailsForUSAppraisal.lastAppraisalPercentageChange != Infinity) {

        if (appraisalDetailsForUSAppraisal.currentAppraisalValue != null && appraisalDetailsForUSAppraisal.currentAppraisalValue != 0
          && appraisalDetailsForUSAppraisal.lastAppraisedValue != null && appraisalDetailsForUSAppraisal.lastAppraisedValue != 0
        ) {
          let percentage =
            ((Number(appraisalDetailsForUSAppraisal.currentAppraisalValue.toString().replace(/,/g, "")) -
              Number(appraisalDetailsForUSAppraisal.lastAppraisedValue.toString().replace(/,/g, ""))) /
              Number(appraisalDetailsForUSAppraisal.lastAppraisedValue.toString().replace(/,/g, ""))) *
            100;
          return parseFloat(percentage.toFixed(2));
        }else {
          return appraisalDetailsForUSAppraisal.lastAppraisalPercentageChange;
        }

      }else{
        return null;
      }
    }else{
      return null;
    }
  } 
  useEffect(() => {
    if (currencyObj?.countryCode != "ZH") {
      setCurrencySymbol(currencySymbolMap(currencyObj?.countryCode) as string);
    } else {
      setCurrencySymbol("ZH");
    }
  }, [currencyObj]);

  const handleCurrencyChange = (value: AllCountriesModel) => {
    setCurrencyObj(value);
    dispatch(
      updateAppraisalDetailsForUSAppraisal({
        ...appraisalsDetails,
        currencySelected: value.countryCode,
      })
    );
  };

  const handleCurrentAppraisalValueChange = (value: string) => {
    const plainNumber = value.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
      dispatch(
        updateAppraisalDetailsForUSAppraisal({
          ...appraisalsDetails,
          currentAppraisalValue: formatedValue,
        })
      );
      if (modifiedAsset.length === 1) {
        var assets = JSON.parse(JSON.stringify(modifiedAssets));
        assets[0] = { ...assets[0], currentAppraisalValue: formatedValue };
        dispatch(updateAppraisalAssets(assets));
      }
    }
    
  };

  const handleLastAppraisedValueChange = (value: string) => {
    const plainNumber = value.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
      dispatch(
        updateAppraisalDetailsForUSAppraisal({
          ...appraisalsDetails,
          lastAppraisedValue: formatedValue,
        })
      );
      if (modifiedAsset.length === 1) {
        var assets = JSON.parse(JSON.stringify(modifiedAssets));
        assets[0] = { ...assets[0], lastAppraisedValue: formatedValue };
        dispatch(updateAppraisalAssets(assets));
      }
    }
    
  };

  const handleLastAnnualAppraisedValueChange = (value: string) => {
    const plainNumber = value.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
      dispatch(
        updateAppraisalDetailsForUSAppraisal({
          ...appraisalsDetails,
          lastAnnualAppraisedValue: formatedValue,
        })
      );
      if (modifiedAsset.length === 1) {
        var assets = JSON.parse(JSON.stringify(modifiedAssets));
        assets[0] = { ...assets[0], lastAnnualAppraisedValue: formatedValue };
        dispatch(updateAppraisalAssets(assets));
      }
    }
    
  };

  const handleEffectiveDateOfValue = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateAppraisalDetailsForUSAppraisal({
          ...appraisalsDetails,
          effectiveDateOfValue: d.format("MM-DD-YYYY"),
        })
      );
    }
  };

  const handleLastAppraisedDateOfValue = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateAppraisalDetailsForUSAppraisal({
          ...appraisalsDetails,
          lastAppraisedDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };

  const handleLastAnnualAppraisedDateOfValue = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateAppraisalDetailsForUSAppraisal({
          ...appraisalsDetails,
          lastAnnualAppraisedDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };

  const handleSheduledNValueChange = (value: string) => {
    const plainNumber = value.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
    dispatch(
      updateAppraisalDetailsForUSAppraisal({
        ...appraisalsDetails,
        sheduled_n_cost: formatedValue,
      })
    );
  }
  };

  const handleGPAppraisalValueChange = (value: string) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      dispatch(
        updateAppraisalDetailsForUSAppraisal({
          ...appraisalsDetails,
          GPAppraisalValue: formatedValue,
        })
      );
    }
  };
  
  const formatNumberWithCommas = (num: number | string | null) => {
    if(num != null)
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');

    return '';
  }

  const handlePercentageChange = () => {
    if (appraisalsDetails.currentAppraisalValue !== 0 && appraisalsDetails.currentAppraisalValue !== null && appraisalsDetails.currentAppraisalValue !== "0") {
      var lastValuePercentage;
      var lastAnnualValuePercentage;
      if (appraisalsDetails.lastAppraisedValue != 0 && appraisalsDetails.lastAppraisedValue != null && appraisalsDetails.lastAppraisedValue != "0") {
        let percentage =
          ((Number(appraisalsDetails.currentAppraisalValue.toString().replace(/,/g,"")) -
          Number(appraisalsDetails.lastAppraisedValue.toString().replace(/,/g,""))) /
          Number(appraisalsDetails.lastAppraisedValue.toString().replace(/,/g,""))) *
          100;
        lastValuePercentage = (percentage.toFixed(2));
      }
      if (appraisalsDetails.lastAnnualAppraisedValue != 0 && appraisalsDetails.lastAnnualAppraisedValue != null && appraisalsDetails.lastAnnualAppraisedValue != "0") {
        let percentage =
          ((Number(appraisalsDetails.currentAppraisalValue.toString().replace(/,/g,"")) -
          Number(appraisalsDetails.lastAnnualAppraisedValue.toString().replace(/,/g,""))) /
          Number(appraisalsDetails.lastAnnualAppraisedValue.toString().replace(/,/g,""))) *
          100;
        lastAnnualValuePercentage = (percentage.toFixed(2));
      }
      dispatch(
        updateAppraisalDetailsForUSAppraisal({
          ...appraisalsDetails,
          lastAppraisalPercentageChange: lastValuePercentage,
          lastAnnualAppraisalPercentageChange: lastAnnualValuePercentage,
        })
      );
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{ minWidth: 650 }}
        size="small"
        aria-label="a dense table"
        className="appraisal-value-table"
      >
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>% Change</TableCell>
            <TableCell>Effective Date of Value <span style={{color:'red'}}>*</span></TableCell>
            <TableCell>Schedule - N <span style={{color:'red'}}>*</span></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Current Appraised Value <span style={{color:'red'}}>*</span></TableCell>
            <TableCell>
              <Autocomplete
                clearIcon={null}
                readOnly={props.flagToDisableControlesForAppraisal || props.view}
                id="Currency"
                options={props.countriesData.sort((a: any, b: any) =>
                  a.countryCode.localeCompare(b.countryCode)
                )}
                value={currencyObj}
                // value={props.countriesData.filter((a:AllCountriesModel)=> a.countryCode == appraisalsDetails.currencySelected)}
                getOptionLabel={(option: AllCountriesModel) => {
                  return option.countryCode;
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.countryCode}
                  </Box>
                )}
                onChange={(e, value) => {
                  handleCurrencyChange(value as AllCountriesModel);
                }}
                sx={{ width: 120 }}
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  name="CurrentAppraisalValue"
                  type='text'
                  id="outlined-adornment-amount"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  value={appraisalsDetails.currentAppraisalValue}
                  onChange={(e) =>
                    handleCurrentAppraisalValueChange(
                      e.target.value
                    )
                  }
                  onBlur={() => handlePercentageChange()}
                  error={!appraisalsDetails.currentAppraisalValue && isSubmit}
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell></TableCell>
            <TableCell>
              <LocalizationProvider  dateAdapter={AdapterDayjs}>
                <DemoContainer sx={{overflowY:'hidden'}} components={["DatePicker"]}>
                  <DatePicker
                    name="EffectiveDateOfValue"
                    readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                    format="MMM-DD-YYYY"
                    value={
                      appraisalsDetails.effectiveDateOfValue === "" ||
                        appraisalsDetails.effectiveDateOfValue == null
                        ? null
                        : dayjs(
                          appraisalsDetails.effectiveDateOfValue,
                          "MM-DD-YYYY"
                        )
                    }
                    views={["month", "day", "year"]}
                    onChange={(newValue: Dayjs | null) =>
                      handleEffectiveDateOfValue(newValue)
                    }
                    slotProps={{ textField: { size: "small",placeholder:"MMM-DD-YYYY" } }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  name="SheduledNValue"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  type="text"
                  id="outlined-adornment-amount"
                  value={appraisalsDetails.sheduled_n_cost}
                  onChange={(e) =>
                    handleSheduledNValueChange(e.target.value)
                  }
                  error={!appraisalsDetails.sheduled_n_cost && isSubmit}
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <span className="table-link-wrap">
                Last Appraised Value <IconButton onClick={() => { props.openLastAppraisalValue("GetLastPostedAppraisalIdByInv"); }}><OpenInNewIcon fontSize="small" /></IconButton>
              </span>
            </TableCell>
            <TableCell> </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  readOnly = {!props.postEditForAdmin}
                  className="Autopopulatefield"
                  value={appraisalsDetails.lastAppraisedValue}
                  type="text"
                  id="lastAppraisedValue"
                  onChange={(e) =>
                    handleLastAppraisedValueChange(
                      e.target.value
                    )
                  }
                  onBlur={() => handlePercentageChange()}
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  readOnly
                  value={appraisalsDetails.lastAppraisalPercentageChange}
                  className="Autopopulatefield"
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">%</InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer sx={{overflowY:'hidden'}} components={["DatePicker"]} >
                  <DatePicker
                    readOnly={!props.postEditForAdmin}
                    name="lastAppraisedDate"
                    format="MMM-DD-YYYY"
                    className="Autopopulatefield"
                    value={
                      appraisalsDetails.lastAppraisedDate === "" ||
                        appraisalsDetails.lastAppraisedDate == null
                        ? null
                        : dayjs(
                          appraisalsDetails.lastAppraisedDate,
                          "MM-DD-YYYY"
                        )
                    }
                    onChange={(newValue: Dayjs | null) =>
                      handleLastAppraisedDateOfValue(newValue)
                    }
                    views={["month", "day", "year"]}
                    slotProps={{ textField: { size: "small" , placeholder:"MMM-DD-YYYY",disabled:true} }}
                  />
                </DemoContainer>
              </LocalizationProvider>

              {/* <OutlinedInput
                  readOnly
                  value={
                    appraisalsDetails.lastAppraisedDate}
                  className="Autopopulatefield"
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">%</InputAdornment>
                  }
                /> */}
            </TableCell>
            <TableCell>GP Appraisal Value</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <span className="table-link-wrap">
                Annual Appraised Value <IconButton onClick={() => props.openLastAppraisalValue("GetLastAnnualPostedAprslByInv")}><OpenInNewIcon fontSize="small" /></IconButton>
              </span>
            </TableCell>
            <TableCell> </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  readOnly = {!props.postEditForAdmin}
                  value={appraisalsDetails.lastAnnualAppraisedValue}
                  className="Autopopulatefield"
                  type="text"
                  id="outlined-adornment-amount"
                  onChange={(e) =>
                    handleLastAnnualAppraisedValueChange(
                      e.target.value
                    )
                  }
                  onBlur={() => handlePercentageChange()}
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  readOnly
                  value={appraisalsDetails.lastAnnualAppraisalPercentageChange}
                  className="Autopopulatefield"
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">%</InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer sx={{overflowY:'hidden'}} components={["DatePicker"]}>
                  <DatePicker
                    readOnly={!props.postEditForAdmin}
                    name="lastAnnualAppraisedDate"
                    format="MMM-DD-YYYY"
                    className="Autopopulatefield"
                    value={
                      appraisalsDetails.lastAnnualAppraisedDate === "" ||
                        appraisalsDetails.lastAnnualAppraisedDate == null
                        ? null
                        : dayjs(
                          appraisalsDetails.lastAnnualAppraisedDate,
                          "MM-DD-YYYY"
                        )
                    }
                    onChange={(newValue: Dayjs | null) =>
                      handleLastAnnualAppraisedDateOfValue(newValue)
                    }
                    views={["month", "day", "year"]}
                    slotProps={{ textField: { size: "small"  , placeholder:"MMM-DD-YYYY",disabled:true} }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </TableCell>
            <TableCell> 
              <FormControl size="small">
                <OutlinedInput
                  name="GPAppraisalValue"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  type="text"
                  id="outlined-adornment-amount"
                  value={formatNumberWithCommas(appraisalsDetails.GPAppraisalValue)}
                  onChange={(e) =>
                    handleGPAppraisalValueChange(e.target.value)
                  }
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
